import React from 'react';
import PropTypes from 'prop-types';

const ContinueButton = ({ buttonText, destination, clickHandler }) => (
  <a
    data-test="continue-button"
    href={destination} // todo extract into own component and add modal to this local state
    className="btn btn-primary"
    onClick={clickHandler}
  >
    {buttonText}
  </a>
);

ContinueButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  clickHandler: PropTypes.func
};

ContinueButton.defaultProps = {
  clickHandler: () => {}
};

export default ContinueButton;
